<template>
  <transition name="slide-fade"  >
    <div  id="academicsHolder" class="uk-padding uk-background-muted" style="min-height: 85vh;">
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Become a part of our great workforce and help us deliver Christ-centred
              education.
            </p>
          </div>
        </div>-->


        <div class=" uk-padding uk-padding-remove-vertical">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Careers</h1>
            <div class="uk-child-width-1-2@m" uk-grid>
              <div v-for="item in loadCareers">
                <div class="uk-card uk-card-default">

                  <div class="uk-card-body">
                    <h4 class="specHeading1">{{ item.acf.job_name }}</h4>
                    <div>
                      <span class="uk-text-small uk-text-muted">Department: </span> <span class="uk-text-small" style=" color: #333 !important; font-weight: bold">{{ item.acf.department }}</span>
                      <br>
                      <span class="uk-text-small uk-text-muted">Application Deadline: </span><span class="uk-text-small">
                        <span class="uk-text-capitalize uk-text-muted"
                              style="font-size: 10pt; color: #333 !important; font-weight: bold">
                              {{ item.acf.job_closing_date | moment("dddd, MMMM Do YYYY") }}
                            </span></span>
                      <br><br>
<!--                   <a  target="_blank" :href="'http://cmsapi.ncu.edu.jm/' + item.jobDescription" class="uk-button uk-button-default uk-align-right">View Job Offer</a>-->



                      <a  :href="item.acf.job_advert"
                         target="_blank"
                          @click="Counter(item)"
                         class="uk-button uk-button-default uk-button-small uk-text-primary uk-margin-small-right"
                             style="font-variant: all-small-caps"
                    >View Offer</a>
                      <a  :id="item.id" :href="item.acf.job_description"
                          target="_blank"

                          class="uk-button uk-button-default uk-button-small uk-text-primary uk-margin-small-right"
                          style="font-variant: all-small-caps"
                      >View Description</a>
<!--                      <a   href="#" class="uk-margin-left"><img src="@/assets/eye.svg" width="20" height="20" alt=""> {{item.counter}} </a>-->
<!--                    <a :href="'https://cmsapi.ncu.edu.jm/' + item.jobDescription"-->
<!--                       target="_blank"-->
<!--                         class="uk-button uk-button-default uk-button-small uk-text-primary"-->
<!--                      >View Description</a>-->

                                            </div>
                                          </div>
                                        </div>
                                      </div>


                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </transition>
                        </template>

                        <script>
                        import {mapActions} from 'vuex'
                            export default {
                                name: "careers",
                              computed:{
                                loadCareers: function () {
                                  //this.pageLoad = true
                                  console.log(this.$store.state.AllJobsList)
                                  return this.$store.state.AllJobsList

                                },
                              },
                              methods: {
                                  ...mapActions([
                                      'Counter'
                                  ]),
                                toDate: function (dateStr) {
                                  const [day, month, year] = dateStr.split("-")
                                  //return new Date(year, month - 1, day)
                                  return  new Date(dateStr.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
                                },

                              },
                                beforeCreate(){
                                  this.$store.dispatch('AllCareers')
                                },
                                mounted(){
                                  window.scrollTo(0, 0);
                                },
                              metaInfo: {
                                // Children can override the title.
                                title: 'NCU Careers',
                                // Result: My Page Title ← My Site
                                // If a child changes the title to "My Other Page Title",
                                // it will become: My Other Page Title ← My Site
                                //titleTemplate: '%s ← My Site',
                                // Define meta tags here.
                                meta: [
                                  {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                                  {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                                  {name: 'description', content: 'Jobs/Careers open at Northern Caribbean University '}
                                ]
                              }
                            }
                        </script>

                        <style scoped>
                          .uk-card-body{
                            padding-bottom: 15px !important;
                          }
                        </style>
